module.exports = __webpack_public_path__ + "img/bbdc-1.dbdd577c.jpg";